import { makeStyles, TextField } from '@material-ui/core';
import React from 'react';

import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => {
  return {
    input: {
      zIndex: 200000,
      width: '100%',
      backgroundColor: '#fff',
      '& .MuiOutlinedInput-root': {
        paddingRight: 0,
      },
    },
    button: {
      height: '50px',
      minWidth: 0,
    },
  };
})

interface FilterFieldType {
  onChange: (e: any) => void;
  value: string;
}

export default function FilterField({ onChange, value }: FilterFieldType) {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <TextField
      className={classes.input}
      onChange={onChange}
      value={value}
      variant='outlined'
      InputLabelProps={{ shrink: true }}
      label={intl.formatMessage({ id: 'STORE.SELECT_PICKUP_POINT' })}
    />
  );
}
